import { NgModule } from '@angular/core';
import { SurveyEditorComponent } from './survey-editor.component';
import { CommonModule } from '@angular/common';  
import { BrowserModule } from '@angular/platform-browser';
import { TranslatorModule } from './translator/translator.module';
import { HttpClientModule } from '@angular/common/http';
import { QuestionEditorComponent } from './question-editor/question-editor.component';
import { FormsModule } from '@angular/forms';
import { SurveyInfosEditComponent } from './survey-infos-edit/survey-infos-edit.component';
import { LinkInfosEditComponent } from './link-infos-edit/link-infos-edit.component';



@NgModule({
  declarations: [SurveyEditorComponent, QuestionEditorComponent, SurveyInfosEditComponent, LinkInfosEditComponent],
  imports: [
    CommonModule,
    TranslatorModule,
    HttpClientModule,
    BrowserModule,
    FormsModule
  ],
  exports: [SurveyEditorComponent]
})
export class SurveyEditorModule { }
